import React from 'react';
import { TabsProps } from "antd/lib/tabs";
import { useSearchParams } from "react-router-dom";

import { Tabs as TabsAnt } from "antd";
import './style.scss';

interface PropsInterface extends TabsProps {
  paramsKey?: string;
  styleType?: 'style1';
}

// Which panes this render actually has.
function tabKeys(props: PropsInterface): string[] {
  if (props.items) {
    return props.items.map(item => String(item.key));
  }

  const keys: string[] = [];

  React.Children.forEach(props.children, child => {
    const key = React.isValidElement(child) ? child.key : null;

    // React prefixes explicit keys with `.$`.
    if (key) keys.push(String(key).replace(/^\.\$/, ''));
  });

  return keys;
}

const Tabs = (props: PropsInterface) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const newProps = {...props};
  const paramsKey = props.paramsKey;

  let className = 'v-tabs';
  className = props.styleType ? `${className} v-tabs--${props.styleType}` : className;
  className = props.className ? `${className} ${props.className}` : className;

  delete newProps.styleType;
  delete newProps.paramsKey;

  function onChangeTab(e: any) {
    if (!paramsKey) {
      return;
    }

    searchParams.set(paramsKey, e);
    searchParams.delete('page');
    setSearchParams(searchParams)

    if (typeof props.onChange === 'function') {
      props.onChange(e);
    }
  }

  if (paramsKey) {
    const urlKey = searchParams.get(paramsKey);

    newProps.onChange = onChangeTab;
    newProps.defaultActiveKey = urlKey || props.defaultActiveKey || '';

    // Controlled on top of that, so a deep link still lands when the tab it
    // names only appears once data arrives — `defaultActiveKey` is read at
    // mount, before those panes exist, and antd falls back to the first tab.
    // Left uncontrolled while the pane is missing.
    if (urlKey && tabKeys(props).includes(urlKey)) {
      newProps.activeKey = urlKey;
    }
  }

  return (
    <TabsAnt {...newProps} className={className}>
      {props.children}
    </TabsAnt>
  );
}

export default Tabs;
